import BaseService from "./base.service";

class TransactionsService extends BaseService {
  get entity() {
    return "gateways/mercadopago/";
  }

  createMercadoPagoPayment(orderId, userId) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: false })
        .post(`gateways/mercadopago/payment`, {
          orderId: orderId,
          userId: userId,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  getMercadoPagoPreference(preferenceId, orderId) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: false })
        .get(`gateways/mercadopago/preference/${preferenceId}/order/${orderId}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }
}

export default new TransactionsService();
